import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import { Line } from "react-chartjs-2";
import { useMemo, useState } from "react";
import { ChartOptions } from "chart.js";
import Legend from "./Legend";
import { ChartYear } from "@arelia-types/earnings";
import { Box, useTheme } from "@mui/material";

type Props = {
  dataProps: ChartYear;
  loading: boolean;
  error: boolean;
  title: string;
};

export default function AllearningsPresenter({ loading, error, dataProps, title }: Props) {
  const [labels, setLabels] = useState(["thisYear", "lastYear"]);
  const theme = useTheme();

  const tooltipLabels = {
    lastYear: "Last Year",
    thisYear: "This Year"
  };

  const chartData = useMemo(() => {
    const entries = Object.entries(dataProps);
    return {
      labels: dataProps.lastYear.labels,
      datasets: entries.filter(([key]) => labels.includes(key))
        .map(([key, { data }]) => {
          return {
            label: tooltipLabels[key as keyof typeof tooltipLabels],
            data: data.map(n => Math.round(n)),
            backgroundColor: key === "thisYear" ? theme.palette.primary.main : "#D758DF",
            borderColor: key === "thisYear" ? theme.palette.primary.main : "#D758DF",
            key: key
          }
        })
    };
  }, [dataProps, labels]);

  const options: ChartOptions<'line'> = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      }
    },
  };

  return (
    <WidgetCard
      widgetId="ALL_EARNINGS"
      title={title}
      loading={loading}
      error={error}
      headerComponent={<Legend labels={labels} setLabels={setLabels} />}
    >
      <Box flexGrow="1">
        <Line data={chartData} options={options} />
      </Box>
    </WidgetCard>
  );
}
